import React from "react";
import "../../css/About_New.css";
import { motion } from "framer-motion";
import { FiTarget, FiShield, FiZap, FiAward, FiArrowRight } from "react-icons/fi";
import rbi_certificate from "../../images/rbi-certificate.jpg";

export const About = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } 
    }
  };

  return null;
};
